import { useTranslation } from 'react-i18next';

import { Typography } from '@/shared/components/atoms';

import Farm from '~/images/shared/Farm.svg';
import Packhouse from '~/images/shared/Packhouse.svg';

interface EmptyListProps {
  type: 'farm' | 'packhouse';
}

const EmptyList: React.FC<EmptyListProps> = ({ type }) => {
  const { t } = useTranslation('common');
  return (
    <div className='flex h-full flex-col items-center'>
      <span className='mt-auto flex w-fit items-center justify-center rounded-full bg-primary-100 p-30 text-48 text-primary-default'>
        {type === 'farm' ? <Farm /> : <Packhouse />}
      </span>
      <Typography>
        {type === 'farm' ? t('no-farms-till-now') : t('no-packhouses-till-now')}
      </Typography>
    </div>
  );
};
export default EmptyList;
